<script lang="ts">
  import {onMount, onDestroy} from 'svelte';
  import Image from './RemotionElements/Image.svelte';
  import Subtitle from './RemotionElements/Subtitle.svelte';
  import recap from '@/store/recap';
  import {events} from './RemotionElements/Util';

  let videoElement: HTMLVideoElement;

  export function intializeComposition(video: HTMLVideoElement) {
    console.log('initialize Composition');
    videoElement = video;
    resizeObserver.observe(video);
    resizeComposition();
  }

  let compositionElement: HTMLDivElement;
  let composition: any[] = [];

  const updateOriginalComposition = (properties: any, compositionIndex: number) => {
    const recapComposition = $recap.composition || [];
    const baseCanvas = {
      height: $recap.videoConfig?.height || 1,
      width: $recap.videoConfig?.width || 1
    };

    const currentVideoHeight = parseFloat(window.getComputedStyle(videoElement).height.split('px')[0]);
    const currentVideoWidth = parseFloat(window.getComputedStyle(videoElement).width.split('px')[0]);

    const element = recapComposition[compositionIndex];
    if (!element || !element.properties) throw new Error('no composition properties found');

    if (properties.height) element.properties.height = properties.height * (baseCanvas.height / currentVideoHeight);
    if (properties.width) element.properties.width = properties.width * (baseCanvas.width / currentVideoWidth);

    if (properties.position) {
      if (properties.position.x)
        element.properties.position.x = properties.position.x * (baseCanvas.height / currentVideoHeight);
      if (properties.position.y)
        element.properties.position.y = properties.position.y * (baseCanvas.width / currentVideoWidth);
    }

    recapComposition[compositionIndex] = element;

    recap.update(value => {
      value.composition = recapComposition;
      console.log(recapComposition, 'update recapComposition');
      return value;
    });
  };

  const resizeComposition = () => {
    const recapComposition = $recap.composition || [];
    const baseCanvas = {
      height: $recap.videoConfig?.height || 1,
      width: $recap.videoConfig?.width || 1
    };

    console.log({recap: $recap.composition});

    composition = [];

    const currentVideoHeight = parseFloat(window.getComputedStyle(videoElement).height.split('px')[0]);
    const currentVideoWidth = parseFloat(window.getComputedStyle(videoElement).width.split('px')[0]);

    for (let i = 0; i < recapComposition.length; i++) {
      const element = JSON.parse(JSON.stringify(recapComposition[i]));

      const properties = element.properties;

      if (properties.height) properties.height = properties.height * (currentVideoHeight / baseCanvas.height);
      if (properties.width) properties.width = properties.width * (currentVideoWidth / baseCanvas.width);

      if (properties.position) {
        if (properties.position.x)
          properties.position.x = properties.position.x * (currentVideoHeight / baseCanvas.height);
        if (properties.position.y)
          properties.position.y = properties.position.y * (currentVideoWidth / baseCanvas.width);
      }

      composition.push(element);
    }

    composition = composition;
  };

  const resizeObserver = new ResizeObserver(resizeComposition);
  window.addEventListener(events.compositionUpdate, resizeComposition);

  function showMoveableHighlight(event: Event) {
    const children = Array.from(compositionElement.children);
    const element = event.target as HTMLElement;
    if (!element) return;

    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      child.classList.remove('show');
      if (child.contains(element)) {
        child.classList.add('show');
      }
    }
  }

  onMount(() => {
    window.addEventListener('click', showMoveableHighlight);
  });

  onDestroy(() => {
    window.removeEventListener(events.compositionUpdate, resizeComposition);
    window.removeEventListener('click', showMoveableHighlight);
    resizeObserver.disconnect();
  });
</script>

<div
  bind:this={compositionElement}
  class="composition-container absolute left-0 top-0 h-full w-full overflow-hidden rounded-lg"
>
  {#each composition as element, i}
    {#if element.type === 'image-element'}
      <Image
        properties={element.properties}
        on:propertiesUpdate={event => updateOriginalComposition(event.detail, i)}
      />
    {:else if element.type === 'subtitle-element'}
      <Subtitle
        properties={element.properties}
        on:propertiesUpdate={event => updateOriginalComposition(event.detail, i)}
      />
    {/if}
  {/each}
</div>
